var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.718 26.945C33.3361 30.266 29.1904 33.8875 25.3109 37.7836C7.02804 56.0664 -2.2291 76.4386 4.62375 83.2979C11.4766 90.1507 31.8552 80.8872 50.1316 62.6107C54.0279 58.7291 57.6495 54.5813 60.9702 50.1972",
    stroke: "#585864",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9765 50.1972C71.7572 64.5072 76.1479 77.9686 70.825 83.2915C63.9658 90.1507 43.5936 80.8872 25.3108 62.6107C7.04076 44.3215 -2.21638 23.9557 4.63647 17.0965C9.95933 11.78 23.4208 16.1707 37.7308 26.945",
    stroke: "#585864",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5068 50.1972C34.5068 51.0496 34.8455 51.8672 35.4483 52.47C36.0511 53.0728 36.8686 53.4114 37.7211 53.4114C38.5736 53.4114 39.3912 53.0728 39.994 52.47C40.5968 51.8672 40.9354 51.0496 40.9354 50.1972C40.9354 49.3447 40.5968 48.5271 39.994 47.9243C39.3912 47.3215 38.5736 46.9829 37.7211 46.9829C36.8686 46.9829 36.0511 47.3215 35.4483 47.9243C34.8455 48.5271 34.5068 49.3447 34.5068 50.1972ZM50.6425 22.2072C48.6175 21.8536 48.6175 18.9543 50.6425 18.6072C54.219 17.985 57.5292 16.3119 60.1511 13.8011C62.773 11.2903 64.5877 8.05553 65.364 4.5093L65.4797 3.95002C65.9168 1.95716 68.7583 1.94431 69.2083 3.93073L69.3626 4.58002C70.1679 8.11055 71.9986 11.3244 74.6247 13.8178C77.2507 16.3111 80.555 17.9729 84.1226 18.5943C86.154 18.9479 86.154 21.8664 84.1226 22.2136C80.555 22.835 77.2507 24.4967 74.6247 26.9901C71.9986 29.4835 70.1679 32.6973 69.3626 36.2279L69.2083 36.8772C68.7583 38.87 65.9168 38.8572 65.4797 36.8643L65.3511 36.305C64.5749 32.7588 62.7601 29.5241 60.1382 27.0133C57.5164 24.5025 54.2062 22.8293 50.6297 22.2072H50.6425Z",
    stroke: "#585864",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScience);
export default __webpack_public_path__ + "static/media/science.abfe41ad21ab25c2bae498a328589151.svg";
export { ForwardRef as ReactComponent };